import React, { useEffect, useState } from "react";
import { getCategories } from "../../api/categoryService";
import "../../assets/css/CategoryList.css";
import { FaPlus, FaEye, FaEdit } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { getErrorMessage } from "../../utils/errorHandler";
import { exportCategories } from "../../api/categoryService";

export default function CategoryList() {
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const fetchCategories = async () => {
    try {
      setLoading(true);
      const res = await getCategories();
      // SAFE DATA HANDLING
      const data = res?.data?.data || res?.data || [];
      setCategories(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error("Failed to fetch categories", error);
      alert(getErrorMessage(error));
      setCategories([]);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchCategories();
  }, []);

  const handleExportCategories = async () => {
    try {
      const response = await exportCategories();

      const blob = new Blob([response.data], {
        type: "text/csv",
      });

      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;

      // Get filename from response header if available
      const contentDisposition = response.headers["content-disposition"];

      let fileName = "categories.csv";

      if (contentDisposition) {
        const match = contentDisposition.match(/filename="?(.+?)"?$/);
        if (match?.[1]) {
          fileName = match[1];
        }
      }

      link.setAttribute("download", fileName);

      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error(error);
      alert(getErrorMessage(error));
    }
  };
  return (
    <div className="container-fluid p-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="mb-0">Category List</h5>

        <div className="d-flex align-items-center gap-2">
          <button className="btn btn-success" onClick={handleExportCategories}>
            Export CSV
          </button>

          <button
            className="btn btn-primary d-flex align-items-center gap-2"
            onClick={() => navigate("/category/add")}
          >
            <FaPlus />
            Add Category
          </button>
        </div>
      </div>
      {loading && <p>Loading categories...</p>}
      {!loading && categories.length === 0 && (
        <p className="text-secondary">No categories found</p>
      )}
      <div className="row g-4 justify-content-start">
        {categories.map((cat) => (
          <div className="col-md-6 d-flex" key={cat._id}>
            <div
              className="w-100"
              style={{
                borderRadius: "12px",
                padding: "15px",
                backgroundImage: `
                            linear-gradient(
                              to bottom,
                              rgba(243, 245, 247, 0.6),
                              rgba(35, 70, 102, 0.8)
                            ),
                            url(${cat.coverImageUrl})
                          `,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            >
              <div className="flex-grow-1">
                <div className="d-flex justify-content-between align-items-start mb-2">
                  <h5 className="fw-semibold text-dark mb-0">{cat.name}</h5>
                  <div className="d-flex gap-3">
                    <button
                      className="border-0 bg-transparent p-0"
                      onClick={() => navigate(`/category/view/${cat.slug}`)}
                    >
                      <FaEye size={18} color="black" />
                    </button>
                    <button
                      className="border-0 bg-transparent p-0"
                      onClick={() =>
                        navigate(`/category/edit/${cat.slug}`, {
                          state: {
                            slug: cat.slug,
                            categoryId: cat._id,
                          },
                        })
                      }
                    >
                      <FaEdit size={18} color="black" />
                    </button>
                  </div>
                </div>
                <p className="mb-1">{cat.description || "No description"}</p>
                <p className="mb-1">Products: {cat.productCount ?? 0}</p>
                <p className="mb-1">Tagline: {cat.tagline || "No tagline"}</p>
                <p className="fw-medium mb-0 text-dark">
                  Status: {cat.status || "Inactive"}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
